import { CheckCircle2, AlertCircle, TrendingUp } from 'lucide-react';
import SearchBar from '../SearchBar';

export default function FeaturedHero({ query, setQuery, filterStatus, setFilterStatus, statusCounts }) {
    return (
        <div className="featured-hero">
            <div className="featured-hero-content">
                {/* Hero Header */}
                <div className="featured-hero-header">
                    <h1 className="featured-hero-title">Manage Your Stores</h1>
                    <p className="featured-hero-subtitle">
                        Search and monitor your entire store portfolio in one place
                    </p>
                </div>

                {/* Search Bar */}
                <div className="featured-search-container">
                    <SearchBar
                        query={query}
                        setQuery={setQuery}
                        filterStatus={filterStatus}
                        setFilterStatus={setFilterStatus}
                    />
                </div>

                {/* Stats Grid */}
                <div className="featured-stats-grid">
                    {/* Clean Stores */}
                    <button
                        onClick={() => setFilterStatus(filterStatus === 'clean' ? 'all' : 'clean')}
                        className={`featured-stats-card ${filterStatus === 'clean' ? 'ring-4 ring-white/50' : ''} hover:scale-105 transition-all duration-200 cursor-pointer`}
                    >
                        <div className="featured-stats-icon">
                            <CheckCircle2 size={28} color="white" />
                        </div>
                        <div className="featured-stats-number">{statusCounts.clean}</div>
                        <div className="featured-stats-label">Clean Stores</div>
                        <div className="featured-stats-description">All systems operational</div>
                    </button>

                    {/* Stores with Errors */}
                    <button
                        onClick={() => setFilterStatus(filterStatus === 'error' ? 'all' : 'error')}
                        className={`featured-stats-card ${filterStatus === 'error' ? 'ring-4 ring-white/50' : ''} hover:scale-105 transition-all duration-200 cursor-pointer`}
                    >
                        <div className="featured-stats-icon">
                            <AlertCircle size={28} color="white" />
                        </div>
                        <div className="featured-stats-number">{statusCounts.error}</div>
                        <div className="featured-stats-label">Stores with Errors</div>
                        <div className="featured-stats-description">Issues or changes needed</div>
                    </button>

                    {/* Pending Checks */}
                    <button
                        onClick={() => setFilterStatus(filterStatus === 'pending' ? 'all' : 'pending')}
                        className={`featured-stats-card ${filterStatus === 'pending' ? 'ring-4 ring-white/50' : ''} hover:scale-105 transition-all duration-200 cursor-pointer`}
                    >
                        <div className="featured-stats-icon">
                            <TrendingUp size={28} color="white" />
                        </div>
                        <div className="featured-stats-number">{statusCounts.pending}</div>
                        <div className="featured-stats-label">Pending Checks</div>
                        <div className="featured-stats-description">Not yet validated</div>
                    </button>
                </div>
            </div>
        </div>
    );
}
